// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/invite-qrcode-modal/invite-qrcode-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
